import { LocalTypes } from '../types/ReadabilityAndLengthAnalysis';
import { merge } from 'lodash';
import Loader, { loadWrap } from './mixins/Loader';
import ApiService from '@jobstairs/axios-api-service';
import { isEmpty } from 'lodash';
import tokenService from '@/services/TokenService';
import { removeHighlights } from '@/helpers/PushPullHighlights';

export default function ({ baseURL, endpoint }) {
    const apiService = new ApiService({ baseURL: baseURL });

    return merge(Loader(), {
        state: {
            score: 0,
            thresholdGood: 0,
            thresholdBad: 0,
            lengthScore: 0,
            relatedAdsAvgWordCount: 0,
            wordCount: 0,
            averageScore: 0,
            longestWords: [],
            longestSentences: [],
        },
        getters: {},
        actions: {
            async [LocalTypes.actions.LOAD_READABILITY_AND_LENGTH_ANALYSIS](
                { commit },
                id,
            ) {
                await loadWrap(commit, async () => {
                    const headers =
                        tokenService.getAuthenticationHeader()['headers'];
                    const response = await apiService.get({
                        endpoint: `${endpoint}/${id}`,
                        headers,
                    });

                    if (
                        `${response.status}` === '204' ||
                        isEmpty(response.data)
                    ) {
                        throw new Error('204');
                    }
                    commit(
                        LocalTypes.mutations.SET_SCORE,
                        response.data.betterads.overall_score,
                    );
                    commit(
                        LocalTypes.mutations.SET_RELATED_ADS_AVG_WORD_COUNT,
                        response.data.betterads.avg_word_count,
                    );
                    commit(
                        LocalTypes.mutations.SET_THRESHOLD_BAD,
                        response.data.betterads.threshold_bad,
                    );
                    commit(
                        LocalTypes.mutations.SET_THRESHOLD_GOOD,
                        response.data.betterads.threshold_good,
                    );
                    commit(
                        LocalTypes.mutations.SET_WORD_COUNT,
                        response.data.betterads.word_count,
                    );
                    commit(
                        LocalTypes.mutations.SET_LENGTH_SCORE,
                        response.data.betterads.length_score,
                    );
                    commit(
                        LocalTypes.mutations.SET_AVERAGE_SCORE,
                        response.data.betterads.average_score,
                    );
                    commit(
                        LocalTypes.mutations.SET_LONGEST_WORDS,
                        response.data.longest_words,
                    );
                    commit(
                        LocalTypes.mutations.SET_LONGEST_SENTENCES,
                        response.data.longest_sentences,
                    );
                });
            },
            async [LocalTypes.actions
                .LOAD_READABILITY_FREETEXT_AND_LENGTH_ANALYSIS](
                { commit },
                { text },
            ) {
                await loadWrap(commit, async () => {
                    const cleanText = removeHighlights(text);
                    const headers =
                        tokenService.getAuthenticationHeader()['headers'];
                    const response = await apiService.post({
                        endpoint,
                        data: {
                            text: cleanText,
                            language: 'de',
                        },
                        headers,
                    });

                    if (
                        `${response.status}` === '204' ||
                        isEmpty(response.data)
                    ) {
                        throw new Error('204');
                    }
                    commit(
                        LocalTypes.mutations.SET_SCORE,
                        response.data.betterads.overall_score,
                    );
                    commit(
                        LocalTypes.mutations.SET_RELATED_ADS_AVG_WORD_COUNT,
                        response.data.betterads.avg_word_count,
                    );
                    commit(
                        LocalTypes.mutations.SET_THRESHOLD_BAD,
                        response.data.betterads.threshold_bad,
                    );
                    commit(
                        LocalTypes.mutations.SET_THRESHOLD_GOOD,
                        response.data.betterads.threshold_good,
                    );
                    commit(
                        LocalTypes.mutations.SET_WORD_COUNT,
                        response.data.betterads.word_count,
                    );
                    commit(
                        LocalTypes.mutations.SET_LENGTH_SCORE,
                        response.data.betterads.length_score,
                    );
                    commit(
                        LocalTypes.mutations.SET_AVERAGE_SCORE,
                        response.data.betterads.average_score,
                    );
                    commit(
                        LocalTypes.mutations.SET_LONGEST_WORDS,
                        response.data.longest_words,
                    );
                    commit(
                        LocalTypes.mutations.SET_LONGEST_SENTENCES,
                        response.data.longest_sentences,
                    );
                });
            },
        },
        mutations: {
            [LocalTypes.mutations.SET_RELATED_ADS_AVG_WORD_COUNT]: (
                state,
                relatedAdsAvgWordCount,
            ) => {
                state.relatedAdsAvgWordCount = relatedAdsAvgWordCount;
            },
            [LocalTypes.mutations.SET_WORD_COUNT]: (state, wordCount) => {
                state.wordCount = wordCount;
            },
            [LocalTypes.mutations.SET_SCORE]: (state, score) => {
                if (score < 1) {
                    score = 1;
                }
                state.score = score;
            },
            [LocalTypes.mutations.SET_THRESHOLD_BAD]: (state, threshold) => {
                state.thresholdBad = threshold;
            },
            [LocalTypes.mutations.SET_THRESHOLD_GOOD]: (state, threshold) => {
                state.thresholdGood = threshold;
            },
            [LocalTypes.mutations.SET_LENGTH_SCORE]: (state, lengthScore) => {
                state.lengthScore = lengthScore;
            },
            [LocalTypes.mutations.SET_AVERAGE_SCORE]: (state, score) => {
                state.averageScore = score;
            },
            [LocalTypes.mutations.SET_LONGEST_WORDS]: (state, longestWords) => {
                state.longestWords = longestWords;
            },
            [LocalTypes.mutations.SET_LONGEST_SENTENCES]: (
                state,
                longestSentences,
            ) => {
                state.longestSentences = longestSentences;
            },
        },
    });
}
